import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'primereact/button';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { LegacyInputTextComponent, TextAreaWithValidation } from '../../../components/prime-formik';
import { validationMessages } from '../../../i18n/common';

const i18n = defineMessages({
  jobNamePlaceholder: {
    id: 'placeholder.job',
    defaultMessage: 'Untitled Job Profile',
  },
  save: { id: 'actions.save', defaultMessage: 'Save' },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
});

const buildInitialValues = (jobProfile) => {
  return {
    name: jobProfile.name,
    internalDescription: jobProfile.internalDescription,
  };
}

const buildValidationSchema = (formatMessage) =>
  Yup.object().shape({
    name: Yup.string().required(formatMessage(validationMessages.required)),
  });

const JobProfileEdit = ({ jobProfile, toggleEdit, onEdit }) => {
  const { formatMessage } = useIntl();

  const initialValues = buildInitialValues(jobProfile);
  const validationSchema = buildValidationSchema(formatMessage);

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={(values, { resetForm}) => {
        onEdit(values);
        resetForm();
      }}
    >
      {({ isSubmitting }) => (
        <Form>
          <div className="p-grid p-fluid">
            <div className="p-col-12">
              <FormattedMessage tagName="label" id="attrs.name" defaultMessage="Name" htmlFor="name" />
            </div>
            <div className="p-col-12">
              <Field
                id="name"
                name="name"
                component={LegacyInputTextComponent}
                placeholder={formatMessage(i18n.jobNamePlaceholder)}
              />
            </div>
          </div>
          <div className="p-grid p-fluid">
            <div className="p-col-12">
              <FormattedMessage
                id="attrs.internalDescription"
                defaultMessage="Internal Description"
                htmlFor="internalDescription"
                tagName="label"
              />
            </div>
            <div className="p-col-12">
              <Field id="internalDescription" name="internalDescription" component={TextAreaWithValidation} rows={6} />
            </div>
          </div>
          <div className="p-grid">
            <div className="p-col">
              <Button
                type="submit"
                icon={isSubmitting ? 'pi pi-spin pi-spinner' : ''}
                label={formatMessage(i18n.save)}
                disabled={isSubmitting}
              />
              <Button
                className="p-button-secondary"
                type="button"
                label={formatMessage(i18n.cancel)}
                onClick={toggleEdit}
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

JobProfileEdit.propTypes = {
  toggleEdit: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default JobProfileEdit;
